<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="场站：">
                <el-select style="width: 150px;" v-model="formInline.stationId" filterable placeholder="全部" @change="stationChange">
                    <el-option label="全部" value="" />
                    <el-option v-for="item in stationOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="桩：">
                <el-select style="width: 150px;" v-model="formInline.pileNo" filterable placeholder="全部">
                    <el-option label="全部" value="" />
                    <el-option v-for="item in pileOptions" :key="item.pileNo" :label="item.name" :value="item.pileNo">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="告警类型：">
                <el-select style="width: 120px;" v-model="formInline.alarmType" placeholder="全部">
                    <el-option label="全部" value="" />
                    <el-option label="故障" value="0" />
                    <el-option label="警告" :value="1" />
                </el-select>
            </el-form-item>
            <el-form-item label="告警状态：">
                <el-select style="width: 120px;" v-model="formInline.alarmState" placeholder="全部">
                    <el-option label="全部" value="" />
                    <el-option label="告警中" value="0" />
                    <el-option label="历史告警" :value="1" />
                </el-select>
            </el-form-item>
            <el-form-item label="发生时间：">
                <el-date-picker
                    v-model="formInline.dateRange"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="截止时间"
                    style="width: 380px;"
                />
            </el-form-item>
        </el-form>

        <div class="button_group">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
            <!-- <el-button type="danger" @click="clearAlarm">清除告警</el-button> -->
        </div>
    </div>

    <el-table 
        class="table_wrapper" 
        :data="tableData" 
        :header-cell-style="{'text-align':'left'}" 
        :cell-style="{'text-align':'left'}"
        @selection-change="handleSelectionChange"
    >
        <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
        <el-table-column label="场站" min-width="200" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.stationName || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="桩" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.pileIndex || '-' }}号桩</span>
            </template>
        </el-table-column>
        <el-table-column label="告警类型" min-width="100">
            <template #default="scope">
                <span>{{ filterAlarmType(scope.row.type) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="告警状态" min-width="100">
            <template #default="scope">
                <span :class="scope.row.recoveryTime ? 'status-history' : 'status-active'">
                    {{ scope.row.recoveryTime ? '历史告警' : '告警中' }}
                </span>
            </template>
        </el-table-column>
        <el-table-column label="故障信息" min-width="200" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.desc || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="故障上报时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.time || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="插入时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.createTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="恢复时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.recoveryTime || '-' }}</span>
            </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
    name: 'AlarmManagement',
    data() {
        return {
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            selectedRows: [],
            formInline: {
                stationId: '',
                pileNo: '',
                alarmType: '',
                alarmState: '',
                dateRange: []
            },
            stationOptions: [],
            stationTree: {},
            pileOptions: []
        };
    },
    mounted() {
        this.getList();
        this.getStationOptions();
    },
    watch: {
        '$store.state.stationList': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.stationOptions = newVal;
                }
            },
            immediate: true
        }
    },
    methods: {
        getList() {
            let that = this;
            let param = {};
            param.page = that.currentPage;
            param.pageSize = that.pageSize;

            Object.keys(this.formInline).forEach(key => {
                if (key === 'dateRange' && this.formInline[key] && this.formInline[key].length > 0) {
                    param.beginTime = this.formInline[key][0];
                    param.endTime = this.formInline[key][1];
                } else if (this.formInline[key]) {
                    param[key] = this.formInline[key];
                }
            });
            // 处理alarmType参数等于0的情况
            if (this.formInline.alarmType === '0') {
                param.alarmType = 0;
            }
            // 处理alarmState参数等于0的情况
            if (this.formInline.alarmState === '0') {
                param.alarmState = 0;
            }

            that.$axios.post(that.$store.state.platformApi + "alarm/page", JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    that.tableData = result.data.records;
                    that.total = result.data.total;
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        handleSelectionChange(val) {
            this.selectedRows = val;
        },
        getStationOptions() {
            let that = this;
            that.stationOptions = that.$store.state.stationList || [];
        },
        getTree() {
            let that = this;
            that.$axios.post(that.$store.state.platformApi + "gun/tree/" + that.formInline.stationId, {}).then(result => {
                if (result.code == 200) {
                    that.stationTree = result.data || {};
                    that.pileOptions = that.stationTree.piles || [];
                    that.formInline.pileNo = '';
                }
            });
        },
        stationChange() {
            this.formInline.pileNo = '';
            this.pileOptions = [];
            if (this.formInline.stationId) {
                this.getTree();
            }
        },
        search() {
            this.currentPage = 1;
            this.getList();
        },
        resetSearch() {
            this.formInline = {
                stationId: '',
                pileNo: '',
                alarmType: '',
                alarmState: '',
                dateRange: []
            };
            this.pileOptions = [];
            this.currentPage = 1;
            this.getList();
        },
        filterAlarmType(type) {
            if (type === 0) {
                return '故障';
            } else if (type === 1) {
                return '警告';
            } else {
                return '未知';
            }
        },
        filterAlarmStatus(status) {
            if (status === 0) {
                return '告警中';
            } else if (status === 1) {
                return '历史告警';
            } else {
                return '未知';
            }
        },
        clearAlarm() {
            if (this.selectedRows.length === 0) {
                ElMessage({
                    message: '请选择要清除的告警',
                    type: 'warning'
                });
                return;
            }

            let that = this;
            let ids = this.selectedRows.map(row => row.id);
            
            // 实际请求示例
            // that.$axios.post(that.$store.state.platformApi + "alarm/clear", JSON.stringify(ids)).then(result => {
            //     if (result.code == 200) {
            //         that.getList();
            //         ElMessage({
            //             message: '清除成功',
            //             type: 'success'
            //         });
            //     } else {
            //         that.$message.error(result.message);
            //     }
            // }).catch(error => {
            //     that.$message.error(error.message);
            // });

            // 模拟清除成功
            that.getList();
            ElMessage({
                message: '清除成功',
                type: 'success'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.search_nav {
    padding: 15px;
    background: #fff;
    margin-bottom: 15px;
}

.button_group {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    button {
        margin-right: 10px;
    }
}

.status-active {
    color: #f56c6c;
    font-weight: bold;
}

.status-history {
    color: #67c23a;
}

</style>